<template>
    <div v-if="loading" class="global-block-overlay" role="presentation" aria-hidden="true">
        <div class="overlay-box">
            <i class="el-icon-loading overlay-spinner" aria-hidden="true"></i>
            <div class="overlay-text">{{ loadText }}</div>
        </div>
    </div>
</template>

<script>

export default {
    name: "Loading",
    props: ['loading','loadText'],
    data() {
        return {
        }
    },
    methods: {
    },
}
</script>

<style scoped>
.global-block-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10050;
    /* 确保覆盖在所有内容之上 */
    background: rgba(0, 0, 0, 0.35);
    /* 半透明遮罩 */
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: all;
    /* 拦截所有指针事件，阻止下层交互 */
}

/* 中心盒子样式（可按需调整） */
.global-block-overlay .overlay-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 18px 24px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0);
    /* 使用透明背景，文字/图标为白色 */
    color: #fff;
}

/* 使用 Element 的 loading 图标（el-icon-loading）并放大 */
.overlay-spinner {
    font-size: 40px;
    color: #fff;
}

/* 文字说明 */
.overlay-text {
    margin-top: 10px;
    font-size: 16px;
    color: #fff;
}

</style>
